import React from 'react';
import { useNavigate } from 'react-router-dom';
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

import "../../CSS/styles.css";


// import required modules
import { Autoplay } from "swiper";
import { ItemsData } from '../../Data/ItemsData';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBangladeshiTakaSign, faBowlFood, faFireAlt, faLeaf } from '@fortawesome/free-solid-svg-icons';


const PopularDishes = () => {
    const navigate = useNavigate();
    const Populer = ItemsData?.filter(data => data?.rating?.total_rating / data?.rating?.total_people > 3.50);
    // console.log(Populer);
    return (
        <div className='container w-full mx-auto py-20'>
            <div className="flex flex-col md:flex-row justify-between items-center gap-3 px-5">
                <div className="">
                    <h1 className="text-3xl md:text-6xl font-bold fw-bold capitalize" style={{ fontFamily: "Rajdhani" }}>Most <span className="bg-gray-200">popular</span> dishes</h1>
                    <p className="pt-7">Consectetur numquam poro nemo veniam
                        eligendi rem adipisci quo modi.</p>
                </div>
                <div className="">
                    <h3 onClick={() => navigate("/menu")} className="flex hover:cursor-pointer gap-2 justify-center font-semibold items-center bg-[#ffbb33] py-3 px-5"><img src="https://elanta.app/nazar/starbelly-demo/img/ui/icons/menu.svg" alt="" className="" />Full Menu</h3>
                </div>
            </div>

            <div className="py-10 px-5 w-full mx-auto">
                <>
                    <Swiper
                        loop={true}
                        speed={5000}
                        autoplay={{
                            delay: 1,
                            disableOnInteraction: false,
                        }}
                        slidesPerView={4}
                        spaceBetween={30}
                        modules={[Autoplay]}
                        className={`mySwiper w-full mx-auto`}
                        breakpoints={{
                            320: {
                                // width: 576,
                                slidesPerView: 1,
                            },
                            480: {
                                // width: 576,
                                slidesPerView: 1,
                            },
                            576: {
                                // width: 576,
                                slidesPerView: 2,
                            },
                            768: {
                                // width: 768,
                                slidesPerView: 3,
                            },
                            992: {
                                // width: 768,
                                slidesPerView: 4,
                            },
                        }}

                    >
                        {
                            Populer?.slice(0,7)?.map(data => (
                                <SwiperSlide>
                                    <div className="w-full h-full mx-auto group duration-200 overflow-hidden">
                                        <div className="w-full h-[60%] relative overflow-hidden">
                                            <div className="absolute top-1 right-1 z-10">
                                                {data?.badge === "Vegan" && <h3 className="text-md font-sans bg-green-500 px-2"> <FontAwesomeIcon icon={faLeaf} /> {data?.badge}</h3>}
                                                {data?.badge === "Hot" && <h3 className="text-md font-sans bg-red-500 px-2"> <FontAwesomeIcon icon={faFireAlt} /> {data?.badge}</h3>}
                                                {data?.badge === "Non Veg" && <h3 className="text-md font-sans bg-yellow-500 px-2"> <FontAwesomeIcon icon={faBowlFood} /> {data?.badge}</h3>}
                                            </div>
                                            <img src={data?.img} alt="" className="w-full h-full object-cover group-hover:scale-110 duration-200 " />
                                        </div>
                                        <div className="space-y-2">
                                            <div className="flex justify-between bg-gray-200 items-center gap-2 pl-2">
                                                <h1 className="font-bold text-md">{data?.name}</h1>
                                                <h1 className="font-bold text-xl p-4 bg-[#F5C332]"><FontAwesomeIcon icon={faBangladeshiTakaSign} /> {data?.price}</h1>
                                            </div>
                                            <p className="text-sm text-justify">{data?.desc.slice(0, 120)}</p>
                                            <p className='flex items-center justify-between gap-2'>
                                                <div className="flex items-center gap-2">
                                                    <div className="rating">
                                                        {

                                                            Math.ceil(data?.rating?.total_rating / data?.rating?.total_people) === 1 &&
                                                            <div className="rating">
                                                                <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-yellow-500" checked />
                                                                <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-gray-300" />
                                                                <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-gray-300" />
                                                                <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-gray-300" />
                                                                <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-gray-300" />
                                                            </div>

                                                        }
                                                        {

                                                            Math.ceil(data?.rating?.total_rating / data?.rating?.total_people) === 2 &&
                                                            <div className="rating">
                                                                <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-yellow-500" />
                                                                <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-yellow-500" checked />
                                                                <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-gray-300" />
                                                                <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-gray-300" />
                                                                <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-gray-300" />
                                                            </div>

                                                        }
                                                        {

                                                            Math.ceil(data?.rating?.total_rating / data?.rating?.total_people) === 3 &&
                                                            <div className="rating">
                                                                <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-yellow-500" />
                                                                <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-yellow-500" />
                                                                <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-yellow-500" checked />
                                                                <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-gray-300" />
                                                                <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-gray-300" />
                                                            </div>

                                                        }
                                                        {

                                                            Math.ceil(data?.rating?.total_rating / data?.rating?.total_people) === 4 &&
                                                            <div className="rating">
                                                                <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-yellow-500" />
                                                                <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-yellow-500" />
                                                                <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-yellow-500" />
                                                                <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-yellow-500" checked />
                                                                <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-gray-300" />
                                                            </div>

                                                        }
                                                        {

                                                            Math.ceil(data?.rating?.total_rating / data?.rating?.total_people) === 5 &&
                                                            <div className="rating">
                                                                <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-yellow-500" />
                                                                <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-yellow-500" />
                                                                <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-yellow-500" />
                                                                <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-yellow-500" />
                                                                <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-yellow-500" checked />
                                                            </div>

                                                        }
                                                    </div>
                                                </div>

                                            </p>
                                        </div>
                                        <div className="">
                                            <button onClick={() => navigate(`/checkout/${data?.id}`)} className='text-xl w-full font-semibold bg-[#F5C332] px-4 py-2'>Buy Now</button>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))
                        }

                    </Swiper>
                </>
            </div>



        </div>
    );
};

export default PopularDishes;